import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAuth } from '@/context/AuthContext';
import { formatarCpf, pareceCpf } from '@/lib/cpf';

import {
  AlertaErro,
  AuthShell,
  BotaoPrimario,
  CampoTexto,
  LinkAuth,
} from './AuthShell';

export default function LoginPage() {
  const [identificador, setIdentificador] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(false);

  const { entrar } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const destino = location.state?.from || '/minha-conta';

  const handleIdentificador = (e) => {
    const valor = e.target.value;
    setIdentificador(pareceCpf(valor) ? formatarCpf(valor) : valor);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    setCarregando(true);

    try {
      await entrar(identificador.trim(), senha);
      navigate(destino, { replace: true });
    } catch (err) {
      const status = err?.response?.status;
      if (status === 423) {
        setErro(
          'Conta temporariamente bloqueada por tentativas seguidas. Tente de novo em 30 minutos.',
        );
      } else if (status === 401) {
        setErro('E-mail/CPF ou senha incorretos.');
      } else {
        setErro('Não foi possível entrar agora. Tente novamente.');
      }
    } finally {
      setCarregando(false);
    }
  };

  return (
    <AuthShell
      titulo="Entrar"
      subtitulo="Acesse sua conta do Lily Book Club"
      rodape={
        <>
          Ainda não tem conta? <LinkAuth to="/cadastro">Criar conta</LinkAuth>
        </>
      }
    >
      <form onSubmit={handleSubmit} className="space-y-5">
        <CampoTexto
          rotulo="E-mail ou CPF"
          name="identificador"
          autoComplete="username"
          autoFocus
          required
          placeholder="voce@email.com"
          value={identificador}
          onChange={handleIdentificador}
        />

        <CampoTexto
          rotulo="Senha"
          name="senha"
          type="password"
          autoComplete="current-password"
          required
          placeholder="••••••••"
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
        />

        <div className="-mt-1 text-right">
          <LinkAuth to="/esqueci-senha">Esqueci minha senha</LinkAuth>
        </div>

        <AlertaErro>{erro}</AlertaErro>

        <BotaoPrimario type="submit" carregando={carregando}>
          Entrar
        </BotaoPrimario>
      </form>
    </AuthShell>
  );
}
